import { Box, Grid } from "@mui/material";
import { EventDeliveryConfigForm } from "./EventDeliveryConfigForm";
import { EventDeliveryLogsList } from "./EventDeliveryLogsList";
import { useGetEventDeliveryConfig } from "./hooks/useGetEventDeliveryConfig";

export const EventDeliveryManage = () => {
  const { data: config } = useGetEventDeliveryConfig();
  const isRegistered = Boolean(config?.uid);

  return (
    <Box
      sx={{
        bgcolor: "var(--fx-surface-sunken, #F8FAFC)",
        p: { xs: 2, sm: 3, md: 3.5 },
        width: "100%",
        minHeight: "100%",
        flex: "1 0 auto",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ maxWidth: isRegistered ? 1140 : 760, width: "100%", mx: "auto", transition: "all 0.3s ease", flex: 1 }}>
        {isRegistered ? (
          <Grid container spacing={3} alignItems="flex-start">
            <Grid item xs={12} md={5} lg={4.5}>
              <EventDeliveryConfigForm compact />
            </Grid>
            <Grid item xs={12} md={7} lg={7.5}>
              <EventDeliveryLogsList enabled={isRegistered} />
            </Grid>
          </Grid>
        ) : (
          <EventDeliveryConfigForm />
        )}
      </Box>
    </Box>
  );
};
